import { takeLatest } from 'redux-saga/effects';

import {
  FETCH_SHOP_PRODUCTS,
  CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS,
  ADD_SHOP_PRODUCTS_TO_BASKET,
  REMOVE_SHOP_PRODUCTS_FROM_BASKET,
  FETCH_SHOP_HISTORY,
  FETCH_SHOP_PRODUCT_PROPERTIES,
  START_SHOP_PRODUCT_FREE_TRIAL,
  START_SHOP_PRODUCT_FREE_SUBSCRIPTION,
  FETCH_SHOP_PERMISSIONS,
} from './shopActions';
import {
  fetchShopProductsSaga,
  changeShopProductsFavoriteStatusSaga,
  addShopProductsToBasketSaga,
  removeShopProductsFromBasketSaga,
  fetchShopHistorySaga,
  fetchShopProductsPropertiesSaga,
  startShopProductFreeTrialSaga,
  startShopProductFreeSubscriptionSaga,
  fetchShopPermissionsSaga,
} from './shopSaga';

export function* shopWatchers() {
  yield takeLatest(FETCH_SHOP_PRODUCTS, fetchShopProductsSaga);
  yield takeLatest(CHANGE_SHOP_PRODUCTS_FAVORITE_STATUS, changeShopProductsFavoriteStatusSaga);
  yield takeLatest(FETCH_SHOP_HISTORY, fetchShopHistorySaga);
  yield takeLatest(ADD_SHOP_PRODUCTS_TO_BASKET, addShopProductsToBasketSaga);
  yield takeLatest(REMOVE_SHOP_PRODUCTS_FROM_BASKET, removeShopProductsFromBasketSaga);
  yield takeLatest(FETCH_SHOP_PRODUCT_PROPERTIES, fetchShopProductsPropertiesSaga);
  yield takeLatest(START_SHOP_PRODUCT_FREE_TRIAL, startShopProductFreeTrialSaga);
  yield takeLatest(START_SHOP_PRODUCT_FREE_SUBSCRIPTION, startShopProductFreeSubscriptionSaga);
  yield takeLatest(FETCH_SHOP_PERMISSIONS, fetchShopPermissionsSaga);
}
